// global shared items
require('./shared')

require('./shared_functions')

require('../../../../modules/Offers/js/mtc_script')

require('../site_scripts/mtc_finance_video_overlay')
require('../site_scripts/mtc_wrap_last_word')
require('../site_scripts/mtc_wrap_first_word')

require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')

// offers specific styles
require('../../css/offers.less')